module.exports = function() {
  return new Worker(__webpack_public_path__ + "3a55532b3b02441650f0.worker.js");
};